function initForms() {

    $('section.modal button').on('click', function (e) {
        e.preventDefault(); // Stop the click

        // Show the proper H1
        $('.contact__title').css('display', 'none');
        $('.title_form_' + $(this).attr('data-tab')).css('display', 'block');

        // Show the proper intro
        $('.form--intro').css('display', 'none');
        $('.' + $(this).attr('data-tab') + "_form_intro").css('display', 'block');

        // Show the proper form
        $('.tabbed-forms').css('display', 'none');
        $('#' + $(this).attr('data-tab') + "_form").css('display', 'block');

    });
    $('#coachFormSubmit').on('click', function (e) {
     
        $(".validation-error").hide();
        if (!$("#SchoolSportUrl").val() || !$("#SchoolSportRosterUrl").val() || !$("#PrimarySport").val() || !$("#SportGender").val() || (!grecaptcha || grecaptcha.getResponse().length == 0)) {
            e.preventDefault();
            if (!$("#SchoolSportUrl").val()) {
                $(".validation-error--sport-url").show();
            }
            if (!$("#SchoolSportRosterUrl").val()) {
                $(".validation-error--roster-url").show();
            }
            if (!$("#PrimarySport").val()) {
                $(".validation-error--primary-sport").show();
            }
            if (!$("#SportGender").val()) {
                $(".validation-error--sport-gender").show();
            }
            if (!grecaptcha || grecaptcha.getResponse().length == 0) {
                $(".validation-error--recaptcha").show();
            }
           

        }
    
    });
    $('#nextToSchool').on('click', function (e) {
        $(".validation-error").hide();
        if (!$("#FirstName").val() || !$("#Surname").val() || !$("#Email").val()) {
            if (!$("#FirstName").val()) {
                $(".validation-error--first-name").show();
            }
            if (!$("#Surname").val()) {
                $(".validation-error--last-name").show();
            }
            if (!$("#Email").val()) { $(".validation-error--email").show();}
       
        }
        else {
$('#nextToSchool').hide();
        $(".loader").show();
         GetSchool();
        console.log("Test 2");
        }
        
      
    });
    $('#backToAbout').on('click', function (e) {
        $("#coachFormAbout").show();
        $("#coachFormSchool").hide();
        $(".contact__form-col--sport").hide();
        $("#backToAbout").hide();
        $('#nextToSchool').show();
        $('#nextToSport').hide();
    });
    $('#backToSchool').on('click', function (e) {
        $(".contact__form-col--sport").hide(); 
        $("#coachFormSchool").show();
        $("#coachFormSubmit").hide();
        $("#backToSchool").hide();
        $("#backToAbout").show(); 
        $("#nextToSport").show();

        $(".form-buttons").removeClass("form-buttons--last");
    });
    $('#nextToSport').on('click', function (e) {
        $(".validation-error").hide();
        if (!$("#CollegeUniversity").val() || !$("#CollegeUniversityAddress").val() || !$("#CollegeUniversityUrl").val()) {
            if (!$("#CollegeUniversity").val()) {
                $(".validation-error--college").show();
            }
            if (!$("#CollegeUniversityAddress").val()) {
                $(".validation-error--college-address").show();
            }
            if (!$("#CollegeUniversityUrl").val()) { $(".validation-error--college-url").show(); }

        }
        else {
            $("#coachFormSchool").hide();

            $(".contact__form-col--sport").show();
            $("#backToAbout").hide();
            $("#backToSchool").show();
            $("#nextToSport").hide();
            $("#coachFormSubmit").show();
            $(".form-buttons").addClass("form-buttons--last");
        }
     

    });
}
function GetSchool() {
    console.log("In get school method");
    var emailField = $("#Email").val();
    console.log("Email: %o", emailField);
    return new Promise(function (resolve, reject) {

        var params = {
            email: emailField
        };


        $.ajax({
            url: "/umbraco/surface/CoachRecruitForm/GetSchoolByEmail",
            method: 'post',
            data: params
        }).done(function (result) {
            console.log("Success", result);
            console.log("Test 1");
            $("#CollegeUniversity").val(result["name"])
            $("#CollegeUniversityAddress").val(result["location"])
            $("#CollegeUniversityUrl").val(result["schoolUrl"])
            $(".loader").hide();
            $("#coachFormAbout").hide();
            $("#coachFormSchool").show();
            $('#nextToSchool').hide();
            $('#nextToSport').show(); 
            $("#backToAbout").show();
            resolve(result);
        }).fail(function (result) {
            console.log('Failed', result);
            $("#coachFormAbout").hide();
            $("#coachFormSchool").show();
            $('#nextToSchool').hide();
            $('#nextToSport').show();
            $("#backToAbout").show();
            reject(result);
        });
    });
} 